import { getAuthHeader } from 'rawr/utils/auth'
import { fymApiServer } from 'rawr/utils/urlManipulation'

const SIGNING_ENDPOINT=`${fymApiServer()}/media/api/signed_url`

const wait = (millis=1000) => new Promise(resolve => setTimeout(resolve, millis))

const getPayload = response => {
    if (response.status !== 200 && response.status !== 304) {
        throw 'Unexpected status code'
    }
    return response.json().catch(e => ({}))
}

const signUrl = data =>
    fetch(
      SIGNING_ENDPOINT,
      {method: 'POST', body: JSON.stringify(typeof data === 'string' ? {url: data} : data),
      headers: getAuthHeader()}
    )
    .then(getPayload)

/* Sign the url only if it points to the media distribution  */
export const getSignedUrl = (data) => {
  if (typeof data === 'string') {
    if (/^(https:)?\/\/media(\.(dev|testing|optesting|staging|uat))?\.(academicmerit|ftcb-nonprod)\.com/.test(data)) {
      return signUrl(data).then(res => res.signedUrl);
    }
  } else if (data && data.key && data.bucket) {
      return signUrl(data).then(res => res.signedUrl);
  }
  return Promise.resolve(data);
}

/* call a function that returns a promise and retry if it throws an exception */
export const retryPromise = (func, {timeout=25*1000, interval=1000}={}) => {
    function requestLoop() {
        return func().catch(reason => {
            if (timeout <= 0) {
                throw 'Timeout exceeded'
            }
            return wait(interval).then(() => {
                timeout -= interval
                return requestLoop()
            })
        })
    }
    return requestLoop()
}

/* sign a url and fetch headers until a successful response */
export const waitForUrl = (url, options) =>
    retryPromise(() =>
        signUrl(url)
            .then(({signedUrl}) => fetch(signedUrl, {method: 'HEAD'}))
            .then(getPayload)
        , options
    )



/** WEBPACK FOOTER **
 ** core/client/rawr/utils/retryPromise.js
 **/